var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnectApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1667 7.16667H15.5C14.2167 7.16667 13.1667 8.21667 13.1667 9.5V11H15.5V10.6667H27.1667V29.3333H15.5V29H13.1667V30.5C13.1667 31.7833 14.2167 32.8333 15.5 32.8333H27.1667C28.45 32.8333 29.5 31.7833 29.5 30.5V9.5C29.5 8.21667 28.45 7.16667 27.1667 7.16667Z",
    fill: "#A8ADB2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 13C10.1339 13 7 16.1339 7 20C7 23.8661 10.1339 27 14 27C17.8661 27 21 23.8661 21 20C21 16.1339 17.8652 13 14 13ZM16.8287 20.7582H14.7443V22.8427C14.7443 23.2537 14.411 23.5869 14 23.5869C13.589 23.5869 13.2557 23.2537 13.2557 22.8427V20.7582H11.1712C10.7602 20.7582 10.427 20.4249 10.427 20.0139C10.427 19.6029 10.7602 19.2696 11.1712 19.2696H13.2557V17.1852C13.2557 16.7742 13.589 16.4409 14 16.4409C14.411 16.4409 14.7443 16.7742 14.7443 17.1852V19.2696H16.8287C17.2397 19.2696 17.573 19.6029 17.573 20.0139C17.573 20.4249 17.2397 20.7582 16.8287 20.7582Z",
    fill: "#A8ADB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectApp);
export default __webpack_public_path__ + "static/media/connectApp.4974e224b60954ca4baa838335ab0f10.svg";
export { ForwardRef as ReactComponent };